<template>
    <erros-box :erros="erros"></erros-box>
    <div class="grid">
        <div class="col-12 mb-4">
            <tabela
                :data="reconhecimentoReceitas.fontes"
                :mostrarPesquisa="false"
                :mostrarHeader="false"
                :sortField="'index'"
                :sortOrder="1"
                :paginator="false"
                :mostrarFooter="true"
            >
                <template #conteudo>
                    <Column v-for="coluna of colunas.fontes" :key="coluna.index" :field="coluna.field" :header="coluna.header" :sortable="false" />
                </template>
                <template #footer>
                    <div class="grid mx-0 mt-0">
                        <div class="col-6 p-0">
                            <div class="text-center p-0">{{ reconhecimentoReceitas.fontesReceitas[0].receita }}</div>
                        </div>
                        <div class="col-6 p-0">
                            <div class="text-center p-0">{{ reconhecimentoReceitas.fontesReceitas[0].valor }}</div>
                        </div>
                    </div>
                </template>
            </tabela>
        </div>
        <div class="col-6">
            <tabela
                :data="reconhecimentoReceitas.extratos"
                :mostrarPesquisa="false"
                :mostrarHeader="false"
                :sortField="'index'"
                :sortOrder="1"
                :paginator="false"
            >
                <template #conteudo>
                    <Column class="flex" field="extratos" header="Extratos" :sortable="false">
                        <template #body="slotProps">
                            <span class="flex align-items-center">{{ slotProps.data.extratos }}</span>
                            <Tag
                                severity="danger"
                                class="flex align-items-center ml-3"
                                v-if="slotProps.data.index > 1 && !haPendencias(slotProps.data.acao)"
                                value="Há pendências"
                            ></Tag>
                        </template>
                    </Column>
                    <Column field="acao" header="Ação" :sortable="false">
                        <template #body="slotProps"> {{ slotProps.data.acao }} </template>
                    </Column>
                </template>
            </tabela>
        </div>
        <div class="col-6">
            <tabela
                :data="reconhecimentoReceitas.vigencia"
                :mostrarPesquisa="false"
                :mostrarHeader="false"
                :sortField="'index'"
                :sortOrder="1"
                :paginator="false"
            >
                <template #conteudo>
                    <Column v-for="coluna of colunas.vigencia" :key="coluna.index" :field="coluna.field" :header="coluna.header" :sortable="false" />
                </template>
            </tabela>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            erros: [],
            colunas: {
                fontes: [
                    { index: 1, field: 'fonte', header: 'Fonte' },
                    { index: 2, field: 'previsto', header: 'Previsto' },
                    { index: 3, field: 'realizado', header: 'Realizado' },
                    { index: 4, field: 'porcentagem', header: '%' },
                ],
                fontesReceitas: [
                    { index: 1, field: 'receita', header: '' },
                    { index: 2, field: 'valor', header: '' },
                ],
                extratos: [
                    { index: 1, field: 'extratos', header: 'Extratos' },
                    { index: 2, field: 'acao', header: 'Ação' },
                ],
                vigencia: [
                    { index: 1, field: 'vigencia', header: 'Vigência' },
                    { index: 2, field: 'acao', header: 'Ação' },
                ],
            },
            showDialogAnexo: false,
        };
    },
    props: {
        reconhecimentoReceitas: { type: Object, default: () => {} },
    },
    methods: {
        haPendencias(existeComprovacoesAnexadas) {
            return existeComprovacoesAnexadas == 'Sim' ? true : false;
        },
    },
};
</script>
